import { BoxGeometry, Mesh } from 'three/webgpu'
import GridMaterial from '../materials/GridMaterial'

export default class GridTunnel extends Mesh {
	static defaults = { width: 8, height: 4, depth: 100, offset: 4, grid: {} }

	constructor(options = {}) {
		const { width, height, depth, offset, grid } = { ...GridTunnel.defaults, ...options }

		super(new BoxGeometry(width, height, depth), new GridMaterial(grid))

		this.position.z = offset - depth / 2
		this.visible = false
	}

	set progress(value) {
		this.visible = value > 0.001
		this.material.progress = value
	}

	set time(value) {
		this.material.time = value
	}

	dispose() {
		this.geometry.dispose()
		this.material.dispose()
		this.removeFromParent()
	}
}
